import { ReportConfig, AvailableReportsData, PhaseReportItem } from '../types';

interface PhaseReportDependencies {
    generateReportsMutation: any;
    history: any;
}

export const createPhaseReportConfigs = (
    availableReportsData: AvailableReportsData,
    dependencies: PhaseReportDependencies
): ReportConfig[] => {
    const configs: ReportConfig[] = [];

    if (!availableReportsData?.phase_reports) {
        return configs;
    }

    Object.entries(availableReportsData.phase_reports).forEach(([categoryType, reportsList]) => {
        if (reportsList && reportsList.length > 0) {
            configs.push({
                id: `phase_${categoryType}`,
                name: categoryType,
                option_name: 'school',
                options: reportsList.map((report: PhaseReportItem) => ({
                    ...report,
                    id: report.id,
                    label: report.name,
                })),
                multiple: true,
                selections: null, // No child levels - this is the deepest
        onSubmit: (context) => {
          // context.selections[0] contains the selected schools
          const selectedSchools = (context.selections[0] || []) as unknown as PhaseReportItem[];
                    const payload: any = {};
                    const districtIds: number[] = [];
                    const courseIds: number[] = [];

                    selectedSchools.forEach((item) => {
                        if (item.level === 'district') districtIds.push(item.id);
                        else if (item.level === 'course') courseIds.push(item.id);
                    });

                    // Get the category_id from the first selected item
                    const categoryId = selectedSchools[0]?.category_id;

                    if (districtIds.length > 0) {
                        payload.district = { category: categoryId, ids: districtIds };
                    }
                    if (courseIds.length > 0) {
                        payload.course = { category: categoryId, ids: courseIds };
                    }

                    dependencies.generateReportsMutation.mutate(payload, {
                        onSuccess: ({ response }: any) => {
                            dependencies.history.push({
                                pathname: 'generator/list',
                                state: { generatedReports: response.data, from: '/admin/reports/generator' },
                            });
                        },
                    });
                },
            });
        }
    });

    return configs;
};

